import { environment } from './../environments/environment';
import { CoreModule, LicenseManager } from 'dynamsoft-barcode-reader-bundle';

CoreModule.engineResourcePaths.dbrBundle = new URL('assets/dynamsoft/', document.baseURI).href;

export async function initializeDynamsoft(): Promise<void> {
  await LicenseManager.initLicense(environment.dynamsoft.productKey, {
    executeNow: true
  });

  // webassembly (WASM) required for the barcode functionality
  await CoreModule.loadWasm();
}
